import { FontIcon, Modal } from "@fluentui/react";
import BackBtn from "../../components/Template/Btns/BackBtn";
import TableComponent from "../../components/TableComponent/TableComponent";
import Table, { ColumnsType } from "antd/es/table";
import IsDataNull from "../../components/Template/IsDataNull";
import { useLocation } from "react-router";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import AuditLogColumns from "../../components/EngageTranslationComponent/TableComponent/AuditLogColumns";
import {
  auditLogModalClose,
  fetchDocuments,
  resetTabState,
  // getDocumentAuditLog,
  updateRequestBody,
} from "../../redux/EngageTranslation/EngageTranslationAction";
import AuditLogModal from "../../components/EngageTranslationComponent/Modal/AuditLogModal/AuditLogModal";
import { useAppDispatch } from "../../redux/useAppDispatch";

function AuditLogPage() {
  const location = useLocation();
  const urlDivided = location.pathname.split("/");
  const documentIdFromUrl = Number(urlDivided[urlDivided.length - 2]);
  const dispatch = useAppDispatch();
  const modalStatus = useSelector((state: RootState) => state.engageTranslationState.auditLogPageState.modalStatus);
  const auditData = useSelector((state: RootState) => state.engageTranslationState.auditLogPageState);

  useEffect(() => {
    dispatch(fetchDocuments({ view: "audit-log", documentId: documentIdFromUrl }));

    return () => {
      dispatch(resetTabState("audit-log"));
    };
  }, []);

  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }
      return false;
    };
    const newSortingRequestBody = {
      ...auditData.currentRequestBody,
      sortColumn: sorter.field,
      isAsc: isAscend(sorter.order),
      viewName: "audit-log",
    };
    dispatch(resetTabState("audit-log"));
    dispatch(
      updateRequestBody({
        requestBody: newSortingRequestBody,
        view: "audit-log",
      })
    );
    dispatch(fetchDocuments({ view: "audit-log", documentId: documentIdFromUrl }));
  };
  return (
    <div className="d-flex flex-column full-flex h-100 px-2 overflow-hidden">
      <div className="d-flex align align-items-center mt-3 mb-3 gap-3">
        <BackBtn />
        <h4>{auditData.resultHeading}</h4>
      </div>
      <div className="d-flex flex-column full-flex gap-3 overflow-hidden">
        <TableComponent
          dataSource={auditData.data}
          columns={AuditLogColumns}
          loading={auditData.loading}
          pagination={auditData.pagination}
          handleTableSorting={handleTableSorting}
          documentId={documentIdFromUrl}
          tableKey={"audit-log"}
        />
      </div>
      <AuditLogModal
        openState={modalStatus}
        close={() => dispatch(auditLogModalClose())}
      />
    </div>
  );
}

export default AuditLogPage;
